import React, { FC } from 'react';
import { TooltipRow } from './TooltipRow';
import { InfoDenseIcon, InfoIcon, Tooltip } from '@rubin-dev/goblin';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export type AddressTransactionsTooltipProps = {
  total: string;
  totalReceive: string;
  totalSent: string;
  active?: boolean;
  dense?: boolean;
  network?: string;
};
export const TransactionsTooltip: FC<AddressTransactionsTooltipProps> = ({
  total,
  totalSent,
  totalReceive,
  active,
  dense,
  // network,
}) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      active={active}
      placement="bottom-end"
      label={
        <div className={styles.addressTooltip__wrapper}>
          <TooltipRow label={t('strings.total')} value={total} />
          <TooltipRow label={t('strings.received')} value={totalReceive} />
          <TooltipRow label={t('strings.sent')} value={totalSent} />
          {/*{network && network !== 'BTC' && (*/}
          {/*  <Typography variant="body-14" color="on-surface-primary-2">*/}
          {/*    {t('titles.transactionsExcluded')}*/}
          {/*  </Typography>*/}
          {/*)}*/}
        </div>
      }
    >
      <div className={styles.addressTooltip__iconWrap}>
        {dense ? (
          <InfoDenseIcon className={styles.addressTooltip__icon} />
        ) : (
          <InfoIcon className={styles.addressTooltip__icon} />
        )}
      </div>
    </Tooltip>
  );
};
